export const ArrowBig = ({ right, left, top, bottom, ...props }) => {
  const rotate = {
    top: 'rotate(0deg)',
    right: 'rotate(90deg)',
    bottom: 'rotate(180deg)',
    left: 'rotate(270deg)',
  };
  let transformIcon = rotate.top;

  if (right) {
    transformIcon = rotate.right;
  } else if (left) {
    transformIcon = rotate.left;
  } else if (bottom) {
    transformIcon = rotate.bottom;
  }

  return (
    <svg
      width="24"
      height="35"
      viewBox="0 0 24 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: transformIcon }}
      {...props}
    >
      <path
        d="M10.5 33C10.5 33.8284 11.1716 34.5 12 34.5C12.8284 34.5 13.5 33.8284 13.5 33H10.5ZM13.0607 0.93934C12.4749 0.353553 11.5251 0.353553 10.9393 0.93934L1.3934 10.4853C0.807611 11.0711 0.807611 12.0208 1.3934 12.6066C1.97919 13.1924 2.92893 13.1924 3.51472 12.6066L12 4.12132L20.4853 12.6066C21.0711 13.1924 22.0208 13.1924 22.6066 12.6066C23.1924 12.0208 23.1924 11.0711 22.6066 10.4853L13.0607 0.93934ZM13.5 33L13.5 2L10.5 2L10.5 33H13.5Z"
        fill="white"
      />
    </svg>
  );
};
